import {
  GOOGLE_MAPS_COMPUTE_DRIVING_ROUTE,
  GOOGLE_MAPS_COMPUTE_ROUTES_DISTANCE,
  GOOGLE_MAPS_GET_PLACE_DETAILS,
  GOOGLE_MAPS_GET_PLACE_SUGGESTIONS,
} from "../actions/googleMaps";
import { didInvalidate } from "../utils/errorHandler";

const slice = (data) => ({
  isFetching: false,
  didInvalidate: false,
  data,
});

const INITIAL_STATE = {
  placeSuggestions: slice([]),
  placeDetails: slice(null),
  drivingRoute: slice(null),
  routesDistance: slice(null),
};

const begin = (current) => ({
  ...current,
  isFetching: true,
  didInvalidate: false,
});

const done = (action, empty) => ({
  isFetching: false,
  didInvalidate: didInvalidate(action),
  data: action.payload?.data ?? empty,
});

const fail = (current) => ({
  ...current,
  isFetching: false,
  didInvalidate: true,
});

const googleMaps = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${GOOGLE_MAPS_GET_PLACE_SUGGESTIONS}_PENDING`:
      return { ...state, placeSuggestions: begin(state.placeSuggestions) };
    case `${GOOGLE_MAPS_GET_PLACE_SUGGESTIONS}_FULFILLED`:
      return { ...state, placeSuggestions: done(action, []) };
    case `${GOOGLE_MAPS_GET_PLACE_SUGGESTIONS}_REJECTED`:
      return { ...state, placeSuggestions: fail(state.placeSuggestions) };
    case `${GOOGLE_MAPS_GET_PLACE_DETAILS}_PENDING`:
      return { ...state, placeDetails: begin(state.placeDetails) };
    case `${GOOGLE_MAPS_GET_PLACE_DETAILS}_FULFILLED`:
      return { ...state, placeDetails: done(action, null) };
    case `${GOOGLE_MAPS_GET_PLACE_DETAILS}_REJECTED`:
      return { ...state, placeDetails: fail(state.placeDetails) };
    case `${GOOGLE_MAPS_COMPUTE_DRIVING_ROUTE}_PENDING`:
      return { ...state, drivingRoute: begin(state.drivingRoute) };
    case `${GOOGLE_MAPS_COMPUTE_DRIVING_ROUTE}_FULFILLED`:
      return { ...state, drivingRoute: done(action, null) };
    case `${GOOGLE_MAPS_COMPUTE_DRIVING_ROUTE}_REJECTED`:
      return { ...state, drivingRoute: fail(state.drivingRoute) };
    case `${GOOGLE_MAPS_COMPUTE_ROUTES_DISTANCE}_PENDING`:
      return { ...state, routesDistance: begin(state.routesDistance) };
    case `${GOOGLE_MAPS_COMPUTE_ROUTES_DISTANCE}_FULFILLED`:
      return { ...state, routesDistance: done(action, null) };
    case `${GOOGLE_MAPS_COMPUTE_ROUTES_DISTANCE}_REJECTED`:
      return { ...state, routesDistance: fail(state.routesDistance) };
    default:
      return state;
  }
};

export default googleMaps;
